import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getRevDate, getPointTime, fetchGet, fetchPost } from '../../common/common';
import { updateCheckoutDet } from '../../actions/search-actions'
import store from '../../store';

// import wheel from '../../img/operator.svg';
// import axios from 'axios';

class Seatchart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            seatchart: [],
            stchrt: [],
            error: false,
            fares: [],
            selFare: 0,
            selPick: '',
            selDrop: '',
            selSeat: [],
            selSeatFare: [],
            seatFare: 0,
            disSeatFare: 0,
            showPoint: '',
            countLower: 0,
            countUpper: 0
        }
    }

    componentDidMount() {
        const that = this;
        const url = window.url + '/api/resource/seatArrangementV2?routeID=' + this.props.seat.RouteScheduleId + '&journeyDate=' + getRevDate(this.props.search.searchParams.departDate);
        // const url = window.url + '/api/resource/searchRoutes?fromCityID=14&toCityID=198&journeyDate=2018-02-18';
        fetchGet(url).then(function(data) {
            if (data.APIGetChartMicrositeV2Result.Status) {

                const stchrt = [];
                data.APIGetChartMicrositeV2Result.Seats.forEach(el => {
                    let baseFare = el.Fare;
                    baseFare -= (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                    baseFare -= (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0);
                    const opDisFare = that.props.seat.HasDiscountPolicy ? (that.props.seat.DiscountAmt > 0 ? that.props.seat.DiscountAmt : Math.floor(baseFare * that.props.seat.DiscountPer/100)) : 0;
                    baseFare -= (baseFare > 0 ? parseInt(opDisFare, 10) : 0);
                    el.baseFare = baseFare;
                    stchrt.push(el);
                })


                that.setState({ stchrt: data.APIGetChartMicrositeV2Result.Seats, seatchart: data.APIGetChartMicrositeV2Result });
                that.parseSeats();
            } else {
                that.setState({ error: data.APIGetChartMicrositeV2Result.ErrorMessage })
            }
            // store.dispatch(getSearchResults(data));
        }).catch(function(error) {
            console.log(error);
        });
        if (this.props.seoChartactive) {
            const curr = document.getElementsByClassName("srch-card active");
            const el = curr[curr.length - 1].getBoundingClientRect();
            window.scrollTo(0, el.top);
          }
    }

    parseSeats = () => {
        let lower = {};
        let upper = {};
        let fares = [];
        let countLower = this.state.countLower;
        let countUpper = this.state.countUpper;
        const st = this.state.stchrt;
        st.forEach(el => {
            if (el.baseFare !== 0 && fares.indexOf(el.baseFare) === -1) fares.push(el.baseFare);
            if (el.Deck === 1) {
                if (el.IsAvailable && !el.IsAisle) {
                    countLower++;
                }
                if (Object.keys(lower).indexOf(el.ColumnNo + '') === -1) {
                    lower[el.ColumnNo] = [];
                    if (!el.IsAisle) {
                        lower[el.ColumnNo].push(el);
                    }
                } else {
                    if (!el.IsAisle) {
                        lower[el.ColumnNo].push(el);
                    }
                }
            } else {
                if (el.IsAvailable && !el.IsAisle) {
                    countUpper++;
                }
                if (Object.keys(upper).indexOf(el.ColumnNo + '') === -1) {
                    upper[el.ColumnNo] = [];
                    if (!el.IsAisle) {
                        upper[el.ColumnNo].push(el);
                    }
                } else {
                    if (!el.IsAisle) {
                        upper[el.ColumnNo].push(el);
                    }
                }
            }
        });
        lower = this.parseSt(lower);
        upper = this.parseSt(upper);

        const stchrt = { lower, upper }
        this.setState({ stchrt, fares, countLower, countUpper });
    }

    parseSt = (val) => {
        let keys = Object.keys(val);
        for (let i = 0; i < keys.length; i++) {
            if (keys[i + 1] - keys[i] > 1) {
                val[parseInt(keys[i], 10) + 1] = false;
            }
            if (val[keys[i]] && val[keys[i]].length === 0 && val[keys[i + 1]] && val[keys[i + 1]].length === 0) {
                val[keys[i]] = false;
                delete val[keys[i + 1]];
            }
        }
        return val;
    }

    showPriceBar = () => {
        const loop = this.state.fares;
        return (
            <div style = {{ display: 'flex', padding: '5px 0' }}>
                <div onClick = { () => this.setState({ selFare: 0 }) } style = { this.state.selFare === 0 ? { borderBottom: '2px solid', borderColor: window.color.searchBoxBgColor, color: '#000', padding: '5px 10px', cursor: 'pointer' } : { padding: '5px 10px', cursor: 'pointer' } }>All</div>
                {
                    loop.length > 1 ?
                    loop.map(el => <div key = { el } style = { this.state.selFare === el ? { borderBottom: '2px solid', borderColor: window.color.searchBoxBgColor, color: '#000', padding: '5px 10px', cursor: 'pointer' } : { padding: '5px 10px', cursor: 'pointer' } } onClick = { () => this.setState({ selFare: el }) }>{this.props.search.currency}{ el }</div>)
                    : ''
                }
            </div>
        )
    }

    getHeightForDiv = (el) => {
        // console.log(el);
        for (let i = 0; i < el.length; i++) {
            if (el[i].Width === 1) {
                return '40px';
            } else {
                return '70px';
            }            
        }
        return '40px';
    }

    showLowerSt = () => {
        const loop = this.state.stchrt.lower;
        return (
            <div style = {{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column-reverse',
                background: '#fff',
                // minHeight: (Object.keys(loop).length * 40) + 'px',
                padding: '10px 5px 10px 60px',
                marginBottom: '10px',
                boxShadow: '0 0 2px rgba(0, 0, 0, 0.3)',
                borderRadius: '3px',
                overflow: 'auto',
                justifyContent: "flex-end",
                height:
                this.state.stchrt.upper &&
                Object.keys(this.state.stchrt.upper).length > 0
                ? "unset"
                : "100%",
            }}>
                <span className = 'seatchart-label'>Lower ({ this.state.countLower } Seats)</span>
                <img src = { '/img/operator.svg' } alt = 'driver' />
                { Object.keys(loop).map( (el, index) => {
                    if (loop[el] && loop[el].length > 0) {
                        return (
                            <div
                                key = {index}
                                style = {{
                                    position: 'relative',
                                    display: 'flex',
                                    height: this.getHeightForDiv(loop[el])
                                    // justifyContent: 'space-around'
                                }}
                            >
                                { loop[el].map( (ell, indexx) => {
                                    const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
                                    return (
                                        <div
                                            key = {indexx}
                                            style = { this.generateSeatStyle(ell) }
                                            onClick = { () => this.selSeat(ell) }
                                        >
                                            { ell.IsAvailable ? this.props.search.currency + ell.baseFare : 'Sold' }
                                            { ell.IsAvailable ? <span style = {{
                                                position: 'absolute',
                                                right: ell.Width === 1 ? '0' : '3px',
                                                top: ell.Width === 1 ? '3px' : 'initial',
                                                bottom: ell.Width === 1 ? '3px' : '0',
                                                left: ell.Width === 1 ? 'initial' : '3px',
                                                width: ell.Width === 1 ? '5px' : 'initial',
                                                height: ell.Width === 1 ? 'initial' : '5px',
                                                background: color
                                            }}></span> : '' }
                                        </div>
                                    )
                                }) }
                            </div>
                        )
                    } else {
                        return <div key = {index} style = {{height: '30px'}}></div>
                    }
                }) }
            </div>
        )
    }

    showUpperSt = () => {
        const loop = this.state.stchrt.upper;
        return (
            <div style = {{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column-reverse',
                background: '#fff',
                // minHeight: (Object.keys(loop).length * 40) + 'px',
                padding: '10px 5px 10px 60px',
                // marginBottom: '10px',
                boxShadow: '0 0 2px rgba(0, 0, 0, 0.3)',
                borderRadius: '3px',
                overflow: 'auto'
            }}>
                <span className = 'seatchart-label up'>Upper ({ this.state.countUpper } Seats)</span>
                { Object.keys(loop).map( (el, index) => {
                    if (loop[el] && loop[el].length > 0) {
                        return (
                            <div
                                key = {index}
                                style = {{
                                    position: 'relative',
                                    display: 'flex',
                                    height: this.getHeightForDiv(loop[el])
                                    // justifyContent: 'space-around'
                                }}
                            >
                                { loop[el].map( (ell, indexx) => {
                                    const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
                                    return (
                                        <div
                                            key = {indexx}
                                            style = { this.generateSeatStyle(ell) }
                                            onClick = { () => this.selSeat(ell) }
                                        >
                                            { ell.IsAvailable ? this.props.search.currency + ell.baseFare : 'Sold' }
                                            { ell.IsAvailable ? <span style = {{
                                                position: 'absolute',
                                                right: ell.Width === 1 ? '0' : '3px',
                                                top: ell.Width === 1 ? '3px' : 'initial',
                                                bottom: ell.Width === 1 ? '3px' : '0',
                                                left: ell.Width === 1 ? 'initial' : '3px',
                                                width: ell.Width === 1 ? '5px' : 'initial',
                                                height: ell.Width === 1 ? 'initial' : '5px',
                                                background: color
                                            }}></span> : '' }
                                        </div>
                                    )
                                }) }
                            </div>
                        )
                    } else {
                        return <div key = {index} style = {{height: '30px'}}></div>
                    }
                }) }
            </div>
        )
    }

    saveOrder = () => {
        const srchPrms = this.props.search.searchParams;
        let isGenderCheck = 0;
        if (this.state.selSeat.length > 0 && this.state.selPick !== '' && this.state.selDrop !== '') {
            const that = this;
            const bus = this.props.search.data.filter(function(a){ return that.props.seat.RouteScheduleId === a.RouteScheduleId })[0];
            const pick = this.state.selPick;
            const drop = this.state.selDrop;
            // let seats = [];
            // console.log(seats);
            let postData = {
                routeCode: bus.RouteScheduleId,
                BusType: bus.BusType,
                companyId: bus.CompanyId,
                companyName: bus.CompanyName,
                // mobile: '',
                // email: '',
                // customerName: '',
                journeyDate: bus.JourneyDate,
                pickUpID: pick.PickupID,
                pickUpName: pick.PickupName,
                pickUpTime: pick.PickupTime,
                pickUpAddress: pick.Address,
                pickUpLandmark: pick.Landmark,
                pickUpPhone: pick.ContactNumbers,
                dropOffID: drop.DropoffID,
                dropOffName: drop.DropoffName,
                dropOffTime: drop.DropoffTime,
                fromCityName: srchPrms.fromCity.split('|')[1],
                fromCityId: bus.FromCityID,
                toCityName: srchPrms.toCity.split('|')[1],
                toCityId: bus.ToCityID,
                opHasDiscountPolicy: bus.HasDiscountPolicy,
                opDiscountAmt: bus.DiscountAmt,
                opDiscountPer: bus.DiscountPer,
                isNonRefundable: bus.IsNonRefundable,
                // seats: [],
                // isSleeper: [],
                // isAC: [],
                // hasSTax: [],
                // serviceTax: [],
                // serviceCharge: [],
                // price: [],
                // seats: [{
                //     seats: '',
                //     // name: '',
                //     // age: 0,
                //     // gender: '',
                //     isSleeper: 0,
                //     isAC: 0,
                //     hasSTax: 0,
                //     serviceTax: 0,
                //     serviceCharge: 0,
                //     price: 0
                // }],
                amenities: bus.AmenitiesType,
                // agentID: 0,
                // insurance: ''
                mode: srchPrms.returnDate && srchPrms.mode === 'roundtrip' ? 'roundtrip' : 'oneway'
            };
            const selSeats = this.state.seatchart.Seats;
            let index = 0;
            selSeats.forEach(el => {
                if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
                    postData['seats[' + index + ']'] = el.SeatLabel;
                    postData['gender[' + index + ']'] = el.Gender;
                    postData['isSleeper[' + index + ']'] = el.Width === 2 || el.Height === 2 ? true : false;
                    postData['isAC[' + index + ']'] = el.IsAC;
                    postData['hasSTax[' + index + ']'] = el.HasSTax;
                    postData['serviceTax[' + index + ']'] = el.ServiceTax;
                    postData['serviceCharge[' + index + ']'] = el.ServiceCharge;
                    postData['convenienceCharge[' + index + ']'] = el.ConvenienceCharge;
                    postData['price[' + index + ']'] = el.Fare + (el.ConvenienceCharge) - (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0)- (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                    isGenderCheck = el.HasDoubleSeaterFemaleValidation || el.HasDoubleSlpFemaleValidation || el.HasFemaleValidation ? 1 : isGenderCheck;
                    index++;
                }
            }
            )
            if (srchPrms.token) {
                postData['token'] = srchPrms.token
            }
            //console.log(postData);
            const url = window.url + '/api/expco/ordersave';

            fetchPost(url, postData).then(data => {
                //console.log(data);
                if (postData.mode === 'roundtrip' && !srchPrms.token) {
                    const url = '/search?mode=roundtrip&fromCity=' + srchPrms.toCity + '&toCity=' + srchPrms.fromCity + '&departDate=' + srchPrms.returnDate + '&returnDate=' + srchPrms.departDate + '&token=' + data.orderToken;
                    window.location.href = url;
                } else {
                    Object.keys(data.orderData.onward.seatDetails).forEach(el => {
                        data.orderData.onward.seatDetails[el]['name'] = '';
                        data.orderData.onward.seatDetails[el]['age'] = '';
                    });
                    if (data.orderData.return && data.orderData.return.seatDetails && Object.keys(data.orderData.return.seatDetails).length > 0) {
                        Object.keys(data.orderData.return.seatDetails).forEach(el => {
                            data.orderData.return.seatDetails[el]['name'] = '';
                            data.orderData.return.seatDetails[el]['age'] = '';
                        });
                    }
                    store.dispatch(updateCheckoutDet(data.orderData));
                    if (postData.mode === 'roundtrip') {
                        this.props.history.push('/co/exp/' + data.orderToken);
                    } else {
                        this.props.history.push('/co/exp/' + data.orderToken + '?p=' + isGenderCheck);
                    }
                }
            })
            .catch((err) => console.log(err));
        }
    }

    showPick = () => {
        return (
            <div className = 'pickups'>
                <div className = 'points'>
                    <div className = 'point-inp' onClick = { () => this.setState({ showPoint: 'pick' }) }>
                        <div style = { this.state.selPick === '' ? {} : {
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            fontSize: '0.8rem',
                            color: window.color.searchBoxBgColor
                        }}>Pickup Point</div>
                        <span></span>
                        <div style = {{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: '0.8rem', width: '90%', fontWeight: '500', cursor: 'pointer' }}>{ this.state.selPick === '' ? '' : this.state.selPick.PickupName }</div>
                    </div>
                    <div style = {{ fontSize: '0.75rem', paddingTop: '5px' }}>{ this.state.selPick === '' ? '' : this.state.selPick.Address }</div>
                </div>
                <div className = 'points'>
                    <div className = 'point-inp' onClick = { () => this.setState({ showPoint: 'drop' }) }>
                        <div style = { this.state.selDrop === '' ? {} : {
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            fontSize: '0.8rem',
                            color: window.color.searchBoxBgColor
                        }}>Dropping Point</div>
                        <span></span>
                        <div style = {{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: '0.8rem', width: '90%', fontWeight: '500', cursor: 'pointer' }}>{ this.state.selDrop === '' ? '' : this.state.selDrop.DropoffName }</div>
                    </div>
                    <div style = {{ fontSize: '0.75rem', paddingTop: '5px' }}>{ this.state.selDrop === '' ? '' : this.state.selDrop.DropoffName }</div>
                </div>
                { this.showSelSeats() }
                <div 
                    style = {{
                        padding: '15px 0',
                        textAlign: 'center',
                        color: '#fff',
                        background: this.state.selSeat.length > 0 && this.state.selPick !== '' && this.state.selDrop !== '' ? window.color.buttonColor : '#ddd',
                        marginTop: '15px',
                        borderRadius: '3px',
                        cursor: this.state.selSeat.length > 0 && this.state.selPick !== '' && this.state.selDrop !== '' ? 'pointer' : 'not-allowed'
                    }}
                    onClick = { this.saveOrder }
                >PROVIDE PASSENGER DETAILS</div>
                { this.showPoint() }
            </div>
        )
    }

    showSelSeats = () => {
        if (this.state.selSeat.length > 0) {
            return (
                <div style = {{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem' }}>
                    <div>
                        <div>Selected Seats</div>
                        {/* <div>Fare</div> */}
                        <div style = {{ color: '#000', fontWeight: 500 }}>Total</div>
                    </div>
                    <div style = {{ textAlign: 'right' }}>
                        <div>{ this.state.selSeat.join(', ') }</div>
                        {/* <div>{ this.state.selSeatFare.join(', ') }</div> */}
                        <div style = {{ color: '#000', fontWeight: 500 }}><span className = { this.state.disSeatFare !== 0 ? 'dashed' : '' }>{this.props.search.currency}{ this.state.seatFare }</span>  { this.state.disSeatFare !== 0 && <span>{this.props.search.currency}{ this.state.disSeatFare }</span> }</div>
                    </div>
                </div>
            )
        } else {
            return (
                <div style = {{ textAlign: 'center' }}>
                    Please select seat(s), pick up & drop off<br/>location to continue 
                </div>
            )
        }
        
    }

    showPoint = () => {
        const det = this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId];
        if (this.state.showPoint !== '' && det) {
            const loop = this.state.showPoint === 'pick' ? det.pickups : det.dropPoints;
            const tm = this.state.showPoint === 'pick' ? 'PickupTime' : 'DropoffTime';
            const title = this.state.showPoint === 'pick' ? 'Pickup Point' : 'Dropping Point';
            const name = this.state.showPoint === 'pick' ? 'PickupName' : 'DropoffName';
            const sel = this.state.showPoint === 'pick' ? 'selPick' : 'selDrop';
            return (
                <div className = 'point-opt active'>
                    <div onClick = { () => this.setState({ showPoint: '' }) }>Select { title }</div>
                    { loop.map((el, index) => {
                        return <div key = { index } onClick = { () => this.setState({ [sel] : el, showPoint: '' }) }><div>{ getPointTime(el[tm] ) }</div><div>{ el[name] }</div></div>
                    }) }
                </div>
            )
        } else {
            return <div className = 'point-opt'></div>
        }
    }

    showLegend = () => {
        return (
            <div className = 'legend'>
                <div>
                    <span style = {{ background: '#1fb34b' }}></span>
                    General
                </div>
                <div>
                    <span style = {{ background: '#ddd' }}></span>
                    Selected
                </div>
                <div>
                    <span style = {{ background: '#0295d2' }}></span>
                    Male
                </div>
                <div>
                    <span style = {{ background: '#ec1287' }}></span>
                    Female
                </div>
                <div>
                    <span className = 'st-legend'></span>
                    Seater
                </div>
                <div>
                    <span className = 'st-legend sl'></span>
                    Sleeper
                </div>
            </div>
        )
    }

    selSeat = (val) => {
        let selSeat = this.state.selSeat;
        let selSeatFare = this.state.selSeatFare;
        let seatFare = this.state.seatFare;
        let disSeatFare = this.state.disSeatFare;
        const that = this;
        const bus = this.props.search.data.filter(function(a){ return that.props.seat.RouteScheduleId === a.RouteScheduleId })[0];
        if (val.IsAvailable && (this.state.selFare === 0 || this.state.selFare === val.baseFare)) {
            const index = selSeat.indexOf(val.SeatLabel);
            if (index === -1 && selSeat.length < 6) {
                selSeat.push(val.SeatLabel);
                // selSeatFare.push(this.props.search.currency + val.Fare);
                seatFare += val.Fare;
                if (bus.DiscountAmt > 0 || bus.DiscountPer) {
                    let temp = 0;
                    temp += (val.Fare - (val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0));
                    temp -= (val.HasSTax ? parseInt(val.ServiceTax, 10) : 0);
                    temp -= bus.DiscountAmt > 0 ? bus.DiscountAmt : Math.floor((temp * bus.DiscountPer / 100));
                    temp += (val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0);
                    temp += (val.HasSTax ? parseInt(val.ServiceTax, 10) : 0);
                    disSeatFare += temp;
                }
            }
            if (index >= 0) {
                selSeat.splice(index, 1);
                // selSeatFare.splice(index, 1);
                seatFare -= val.Fare;
                if (bus.DiscountAmt > 0 || bus.DiscountPer) {
                    let temp = 0;
                    temp += (val.Fare - (val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0));
                    temp -= (val.HasSTax ? parseInt(val.ServiceTax, 10) : 0);
                    temp -= bus.DiscountAmt > 0 ? bus.DiscountAmt : Math.floor((temp * bus.DiscountPer / 100));
                    temp += (val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0);
                    temp += (val.HasSTax ? parseInt(val.ServiceTax, 10) : 0);
                    disSeatFare -= temp;
                }
            }
            this.setState({ selSeat, seatFare, disSeatFare, selSeatFare });
        }
    }

    render() {
        if (this.state.stchrt.lower) {
            return (
                <div className = 'seatchart'>
                    <span
                        onClick = { () => this.props.close(this.props.seat.RouteScheduleId) }
                        style = {{
                            position: 'absolute',
                            right: '25px',
                            top: '25px',
                            cursor: 'pointer',
                            fontSize: '1.1rem'
                        }}
                    >&#x2715;</span>
                    { this.showPriceBar() }
                    <div className = 'seat-wrap'>
                        <div className = 'seats'>
                            { this.showLowerSt() }
                            { this.state.stchrt.upper && Object.keys(this.state.stchrt.upper).length > 0 ? this.showUpperSt() : '' }
                        </div>
                        { this.showPick() }
                    </div>
                    { this.showLegend() }
                </div>
            )
        } else {
            return (
                <div className='loading'>
                Loading...
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            )
        }
    }

    generateSeatStyle = (ell) => {
        // console.log(ell)
        const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
        return {
            // position: 'relative',
            position: 'absolute',
            left: (ell.RowNo * 35) + 'px',
            // top: (ell.RowNo * 35) + 'px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: (ell.Height * 33) + 'px',
            height: (ell.Width * 30) + 'px',
            margin: '5px',
            fontSize: ell.Width === 1 ? '0.5rem' : '0.6rem',
            paddingRight: !ell.IsAvailable || ell.Width === 2 ? '0' : '5px',
            border: '1px solid',
            borderColor: !ell.IsAvailable ? '#ddd' : color,
            background: !ell.IsAvailable ? '#ddd' : (this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color : '#fff'),
            color: !ell.IsAvailable || this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? '#fff' : '#444',
            opacity: this.state.selFare !== 0 && this.state.selFare !== ell.baseFare ? 0.2 : 1,
            userSelect: 'none',
            cursor: ell.IsAvailable ? 'pointer' : 'not-allowed'
        }
    }
}


const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(withRouter(Seatchart));